import { render } from "./App.vue?vue&type=template&id=44fb91b2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=44fb91b2&lang=scss"

import exportComponent from "/Volumes/Macintosh HD 1/Users/admin/Documents/micowell/xmai_official_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__